export default "__VITE_ASSET__LW8XVsFh__"